const STORAGE_KEY = 'reader_settings';

export const COLORS = [
  { bg: '#d4d3c8', text: '#000', label: 'Padrão' },
  { bg: '#fff', text: '#000', label: 'Branco' },
  { bg: '#F1EFE0', text: '#000', label: 'Creme' },
  { bg: '#ebebeb', text: '#000', label: 'Cinza claro' },
  { bg: '#333', text: '#fff', label: 'Escuro' }
];

export const FONT_LIST = ['Padrão', 'OpenDyslexic', 'Book Antiqua', 'Georgia', 'Helvetica', 'Arial'];

export const FONT_SIZE_MIN = 100;
export const FONT_SIZE_MAX = 150;

export const DEFAULT_SETTINGS = {
  fontSize: 100,
  fontFamily: 'Padrão',
  backgroundColor: '#d4d3c8',
  textColor: '#000',
  highContrast: false,
  dyslexiaFont: false
};

export function loadReaderSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveReaderSettings(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {}
}

export function getTextColor(bgColor) {
  const color = COLORS.find(c => c.bg === bgColor);
  return color ? color.text : '#000';
}

export function applyReaderSettings(settings) {
  const root = document.documentElement;
  const body = document.body;

  // 1. Determine effective font family
  let effectiveFont;
  if (settings.dyslexiaFont) {
    effectiveFont = "'OpenDyslexic', 'Comic Sans MS', sans-serif";
  } else if (settings.fontFamily === 'Padrão') {
    effectiveFont = "'Poppins-Regular', 'Poppins', -apple-system, sans-serif";
  } else {
    effectiveFont = "'" + settings.fontFamily + "', serif";
  }

  // 2. Determine effective colors (high contrast overrides)
  let effectiveBg = settings.highContrast ? '#000' : settings.backgroundColor;
  let effectiveText = settings.highContrast ? '#fff' : settings.textColor;

  // 3. Compute font size: scale factor + px equivalent for inherited elements
  var scale = settings.fontSize / 100;
  var fontSizePx = scale * 16 + 'px';

  // 4. Apply CSS custom properties
  root.style.setProperty('--reader-font-scale', scale.toString());
  root.style.setProperty('--reader-font-size', fontSizePx);
  root.style.setProperty('--reader-font-family', effectiveFont);
  root.style.setProperty('--reader-bg', effectiveBg);
  root.style.setProperty('--reader-text-color', effectiveText);

  // 5. Apply to body (inherited by elements without explicit font-size)
  body.style.fontSize = fontSizePx;
  body.style.fontFamily = effectiveFont;
  body.style.backgroundColor = effectiveBg;
  body.style.color = effectiveText;

  // 6. Body classes for additional CSS rules
  body.classList.toggle('high-contrast', settings.highContrast);
  body.classList.toggle('dyslexia-font', settings.dyslexiaFont);
  var normalizedBg = effectiveBg.length === 4
    ? '#' + effectiveBg[1] + effectiveBg[1] + effectiveBg[2] + effectiveBg[2] + effectiveBg[3] + effectiveBg[3]
    : effectiveBg;
  body.classList.toggle('theme-dark', normalizedBg.toUpperCase() === '#333333' || normalizedBg.toUpperCase() === '#000000');

  // 7. Update theme-color meta tag
  var meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', effectiveBg);
  }
}
